import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'
import { searchPublishersOptions } from '@App/stores/search/public/public-search-publishers-store'
import clsx from 'clsx'
import { observer } from 'mobx-react'
import MultiplePublisherSelector from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/MultiplePublisherSelector'

const SourcePublisherSelectionStep = () => {
    const { transferSourcePublisherSearchStore, catalogTransferWizardStore } = useContext(StoresContext)

    useEffect(() => {
        const firstSourcePublisher = catalogTransferWizardStore.currentCatalogTransfer?.sourcePublishers?.[0]
        if (firstSourcePublisher?.ipId) {
            transferSourcePublisherSearchStore.searchCriteriaStore.setCriterionOption(
                0,
                searchPublishersOptions[2],
                firstSourcePublisher.hfaPublisherNumber
            )
            transferSourcePublisherSearchStore.setQuery({
                hfaNumber: firstSourcePublisher.hfaPublisherNumber,
            })
            transferSourcePublisherSearchStore.search().then()
        }
    }, [])

    return (
        <div className="publisher-selection-step ct-wizard-step-container">
            <CatalogTransferWizardHeader title="Acquiring">
                <p>Search for and select the Members or publishers whose works you are acquiring.</p>
                <p>You may select multiple if needed.</p>
            </CatalogTransferWizardHeader>
            <section
                className={clsx(
                    'publisher-select',
                    transferSourcePublisherSearchStore.searchResults.length && 'has-searched'
                )}
            >
                <MultiplePublisherSelector
                    store={transferSourcePublisherSearchStore}
                    selectedPublishers={catalogTransferWizardStore.sourcePublishers}
                    onAddPublisher={(publisher) => catalogTransferWizardStore.addSourcePublisher(publisher)}
                    onRemovePublisher={(ipId) => catalogTransferWizardStore.removeSourcePublisher(ipId)}
                    isPublisherSelected={(ipId) => catalogTransferWizardStore.isSourcePublisherSelected(ipId)}
                />
            </section>
        </div>
    )
}

export default observer(SourcePublisherSelectionStep)
